import type { MediaKind } from "../_operations/types";

/** Whether a file is video or audio, by MIME type (defaults to audio). */
export function mediaKindOf(file: File | undefined | null): MediaKind {
  return file?.type.startsWith("video") ? "video" : "audio";
}

/**
 * react-dropzone `accept` map derived from the kinds an operation takes. Keeping
 * this derived from `inputKinds` means the dropzone can never drift out of sync
 * with what the operation actually handles.
 */
export function acceptForKinds(kinds: MediaKind[]): Record<string, string[]> {
  const accept: Record<string, string[]> = {};
  if (kinds.includes("audio")) accept["audio/*"] = [];
  if (kinds.includes("video")) accept["video/*"] = [];
  return accept;
}
